import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorContent } from './ErrorContent';

export const UnAuthorised: React.FC = () => {
  const { t } = useTranslation('errors');

  return (
    <ErrorContent
      title={t('un_authorised_title', 'Unauthorised')}
      description={t('un_authorised_message', 'You are not permitted to view this content.')}
    ></ErrorContent>
  );
};
